import React from "react";
import "./about.css";
import WorkCard from "./WorkCard";
import { motion } from "framer-motion";

import { workexperiences } from "./index.js";

const About = () => {
  return (
    <motion.div
      className="app__about"
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 0.8,
        delay: 0.5,
        ease: [0, 0.71, 0.2, 1.01],
      }}
    >
      <h1 className="h1__text2">About Me</h1>
      <div className="app__about-details">
        <p className="app__about-p">
          My name is Ayeni Paul Boluwatife. I am a Frontend Developer with a
          minimum of two (2) years experience in React JS, I love working in a
          agile and cross functional team. I have a strong Design, Integration
          and Problem solving skills.
        </p>
      </div>
      <div className="app__about-experience">
        <h1 className="h1__text2">Work Experience</h1>

        <div className="work-experience">
          {workexperiences.map((work) => (
            <WorkCard
              title={work.title}
              btn={work.btn}
              company={work.company}
              location={work.location}
              date={work.date}
            />
          ))}
        </div>
      </div>

      <div className="app__about-experience">
        <h1 className="h1__text2">Education</h1>

        <div className="work-experience">
          <WorkCard
            title="Bachelor in Computer Engineering"
            btn="Full Time"
            company="FUTA"
            location="Ondo "
            date="2019 - 2025"
          />
        </div>
      </div>
    </motion.div>
  );
};

export default About;
